import React, { PureComponent } from 'react';
import PageLoaderWithTryAgain from '@client/components/pageLoader/PageLoaderWithTryAgain';
import { getHomePage } from '@client/connectivity/api.home';
import { strings } from '@client/localization/Localization';
import HeroSection from '@client/containers/heroSection/HeroSection';
import UspSection from '@client/containers/uspSection/UspSection';
import FeaturedEpisodesSection from '@client/containers/featuredEpisodesSection/FeaturedEpisodesSection';
import FeaturedSeriesSection from '@client/containers/featuredSeriesSection/FeaturedSeriesSection';
import SlideshowSection from '@client/containers/slideshowSection/SlideshowSection';
import shapes from '@client/shared/js/shapes';
import styles from './homePage.scss';

class HomePage extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      failedToLoadContent: false,
      homePageContent: undefined,
    };
  }

  componentDidMount() {
    this.loadHomePage();
  }

  loadHomePage = () => {
    this.setState({
      failedToLoadContent: false,
    });
    getHomePage()
      .then((homePageContent) => {
        this.setState({
          homePageContent: homePageContent.data,
        });
      })
      .catch((error) => {
        this.setState({
          failedToLoadContent: true,
        });
        console.log(error);
      });
  };

  render() {
    const { homePageContent, failedToLoadContent } = this.state;

    if (!homePageContent) {
      return (
        <PageLoaderWithTryAgain
          tryAgain={true}
          failed={failedToLoadContent}
          onTryAgainClick={this.loadHomePage}
        />
      );
    }

    const {
      featuredEpisodes,
      featuredSeries1,
      featuredSeries2,
      config,
    } = this.state.homePageContent;

    return (
      <div className={styles.homePage}>
        <div>
          <HeroSection
            title={config.heroTitle}
            description={config.heroDescription}
            imageUrl={config.heroImageUrl}
            ctaText={config.heroCtaTitle}
            ctaUrl={config.heroCtaUrl}
            graphicsHeroMobile={shapes.graphic_header_mobile}
            graphicsHero={shapes.graphic_header}
          />
          <UspSection
            title={config.uspTitle}
            description={config.uspDescription}
            imageUrl={config.uspImageUrl}
            ctaText={config.heroCtaTitle}
            ctaUrl={config.uspCtaUrl}
          />
          {featuredEpisodes && (
            <FeaturedEpisodesSection
              episodes={featuredEpisodes}
              sectionTitle={strings.episodes}
              backgroundLines={true}
            />
          )}
          {featuredSeries1 && featuredSeries1.length > 0 && (
            <SlideshowSection slides={featuredSeries1} />
          )}
          {featuredSeries2 && featuredSeries2.length > 0 && (
            <FeaturedSeriesSection
              series={featuredSeries2}
              sectionTitle={strings.series}
            />
          )}
        </div>
      </div>
    );
  }
}

HomePage.propTypes = {};

export default HomePage;
